import { Injectable } from '@angular/core';
import { IQuotation } from '../../../../../@interfaces/quotation.interface';
import {
  UntypedFormArray,
  UntypedFormGroup,
  UntypedFormControl,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ModifySalesService {
  constructor() {}

  setQuotationData(
    registerForm: UntypedFormGroup,
    rowsArr: UntypedFormArray,
    newCustomer: UntypedFormControl,
  ) {
    let setQuotation = {} as IQuotation;
    let total: number = 0;
    setQuotation.tax = registerForm.value.tax;
    setQuotation.cliente = {
      id_cliente: 0,
      nombre: '',
      doc_nit: '',
      direccion: '',
      telefono: '',
      email: '',
      delivery: '',
      country: [],
    };
    setQuotation.cliente.id_cliente = parseInt(newCustomer.value.id_cliente);
    setQuotation.createdAt = registerForm.value.date;
    setQuotation.dueDate = registerForm.value.dueDate;
    setQuotation.seller = {
      id_seller: 0,
      nombre: '',
      doc_nit: '',
      email: '',
      country: [],
    };
    setQuotation.seller = registerForm.value.seller;
    setQuotation.tax_incl = new Boolean(registerForm.value.tax_incl).toString();
    for (let x = 0; x < rowsArr.value.length; x++) {
      total = total + parseFloat(rowsArr.value[x].subtotal);
    }
    setQuotation.venta = [
      {
        id_venta: [],
        codigo: [],
        cantidad: [],
        precio: [],
        descuento: [],
        subtotal: [],
        id_almacen: [],
        id_sale_unit: [],
        quantity_in_base_unit: [],
        total: [],
      },
    ];
    for (let index = 0; index < rowsArr.value.length; index++) {
      if (rowsArr.value[index].ids) {
        setQuotation.venta[0].id_venta.push(parseInt(rowsArr.value[index].ids));
      }
      setQuotation.venta[0].codigo.push(rowsArr.value[index].article.codigo);
      setQuotation.venta[0].cantidad.push(
        parseFloat(rowsArr.value[index].quantity),
      );
      setQuotation.venta[0].precio.push(parseFloat(rowsArr.value[index].price));
      setQuotation.venta[0].descuento.push(
        parseFloat(rowsArr.value[index].discount),
      );
      setQuotation.venta[0].subtotal.push(
        parseFloat(rowsArr.value[index].subtotal),
      );
      setQuotation.venta[0].id_almacen.push(
        parseInt(rowsArr.value[index].warehouse.id_almacen),
      );
      const unitValue = rowsArr.value[index].unit
        ? parseInt(rowsArr.value[index].unit)
        : null;
      const baseQuantity = rowsArr.value[index].quantityInBaseUnit
        ? parseFloat(rowsArr.value[index].quantityInBaseUnit)
        : null;
      setQuotation.venta[0]?.id_sale_unit?.push(unitValue);
      setQuotation.venta[0]?.quantity_in_base_unit?.push(baseQuantity);
      setQuotation.venta[0].total.push(total);
    }
    return setQuotation;
  }
}
